/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Guide_Original_Language_HelpInputs */

const en_knp_guide_original_language_help = /** @type {(inputs: Knp_Guide_Original_Language_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select the original language for this guide`)
};

const fr_knp_guide_original_language_help = /** @type {(inputs: Knp_Guide_Original_Language_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sélectionnez la langue d’origine de ce guide`)
};

const de_knp_guide_original_language_help = /** @type {(inputs: Knp_Guide_Original_Language_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wählen Sie die Originalsprache für diese Anleitung aus.`)
};

const it_knp_guide_original_language_help = /** @type {(inputs: Knp_Guide_Original_Language_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona la lingua originale per questa guida`)
};

const ru_knp_guide_original_language_help = /** @type {(inputs: Knp_Guide_Original_Language_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите исходный язык для этого руководства.`)
};

const es_knp_guide_original_language_help = /** @type {(inputs: Knp_Guide_Original_Language_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccione el idioma original para esta guía`)
};

const zh_cn2_knp_guide_original_language_help = /** @type {(inputs: Knp_Guide_Original_Language_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请选择本指南的原始语言`)
};

const ja_knp_guide_original_language_help = /** @type {(inputs: Knp_Guide_Original_Language_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このガイドの元の言語を選択してください`)
};

const hi_knp_guide_original_language_help = /** @type {(inputs: Knp_Guide_Original_Language_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इस मार्गदर्शिका के लिए मूल भाषा का चयन करें`)
};

const pt_pt2_knp_guide_original_language_help = /** @type {(inputs: Knp_Guide_Original_Language_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione o idioma original deste guia.`)
};

/**
* | output |
* | --- |
* | "Select the original language for this guide" |
*
* @param {Knp_Guide_Original_Language_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_guide_original_language_help = /** @type {((inputs?: Knp_Guide_Original_Language_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Guide_Original_Language_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_knp_guide_original_language_help(inputs)
	if (locale === "de") return de_knp_guide_original_language_help(inputs)
	if (locale === "it") return it_knp_guide_original_language_help(inputs)
	if (locale === "ru") return ru_knp_guide_original_language_help(inputs)
	if (locale === "es") return es_knp_guide_original_language_help(inputs)
	if (locale === "zh-CN") return zh_cn2_knp_guide_original_language_help(inputs)
	if (locale === "ja") return ja_knp_guide_original_language_help(inputs)
	if (locale === "hi") return hi_knp_guide_original_language_help(inputs)
	if (locale === "pt-PT") return pt_pt2_knp_guide_original_language_help(inputs)
	return en_knp_guide_original_language_help(inputs)
});